<template>
  <div class="container-fluid border py-3">
    <div class="row">
      <div class="col-4">
          <img src="../assets/Roombox-navbar.png" alt="" class="img-fluid">
      </div>
      <!-- <div class="col-4 position-absolute top-50 start-50 translate-middle"> -->
      <div class="col-4">
        <img src="../assets/eci-navbar.png" alt="" class="img-fluid">
      </div>
      <div class="col-4">
        <a  href="#" class=" logout text-decoration-none" v-on:click="logout()" >
          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-box-arrow-in-right" style="color:#E94746; text-align:left" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M6 3.5a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v9a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 0-1 0v2A1.5 1.5 0 0 0 6.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-9A1.5 1.5 0 0 0 14.5 2h-8A1.5 1.5 0 0 0 5 3.5v2a.5.5 0 0 0 1 0v-2z"/>
            <path fill-rule="evenodd" d="M11.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H1.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"/>
        </svg>
        Salir
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
    name:'Header',
    methods:{
      logout(){
          this.credentials={
            token:localStorage.token
          };
          axios.post("https://eciadmin.roombox3d.com/users.php", this.credentials)
          .then(data=>{
                if(data.data.statusMsg.code==0){
                  localStorage.token="";
                  this.$router.push('/');
                }
            })
        },
    }
}
</script>


<style >
.container-fluid::after{
  background: #FAFAFA 0% 0% no-repeat padding-box;
  opacity: 0;
}
</style>

